import React from "react";
import { Skeleton } from "./Skeleton";

/**
 * Skeleton: section label, then two separate white panels (MTD block, balances block).
 */
export function ThisMonthInProgressSkeleton() {
  return (
    <div className="flex w-full flex-col items-start gap-4">
      <Skeleton className="h-4 w-48 rounded" />

      <div className="flex w-full flex-col items-start rounded-xl bg-white shadow-md">
        <div className="flex w-full items-end justify-between px-6 pt-6 pb-4">
          <Skeleton className="h-7 w-52 rounded" />
          <Skeleton className="h-4 w-28 rounded" />
        </div>
        <div className="flex w-full flex-wrap gap-4 px-6 pb-8 items-stretch">
          {[1, 2].map((i) => (
            <MtdMetricCardSkeleton key={`mtd-${i}`} variant="comparison" />
          ))}
        </div>
      </div>

      <div className="flex w-full flex-col items-start rounded-xl bg-white shadow-md">
        <div className="flex w-full items-end justify-end px-6 pt-6 pb-4">
          <Skeleton className="h-4 w-28 rounded" />
        </div>
        <div className="flex w-full flex-wrap gap-4 px-6 pb-8 items-stretch">
          {[1, 2, 3].map((i) => (
            <MtdMetricCardSkeleton key={`bal-${i}`} variant="scope" />
          ))}
        </div>
      </div>
    </div>
  );
}

function MtdMetricCardSkeleton({
  variant = "comparison",
}: {
  variant?: "comparison" | "scope";
}) {
  return (
    <div className="flex min-w-[140px] grow shrink-0 basis-0 flex-col items-start overflow-hidden rounded-xl border border-solid border-neutral-200">
      <div className="flex flex-col items-start gap-4 bg-white px-5 py-5">
        <div className="flex w-full items-start justify-between">
          <Skeleton className="h-5 w-24 rounded" />
          <Skeleton className="h-8 w-8 flex-none rounded-full" />
        </div>
        <Skeleton className="h-8 w-28 rounded" />
      </div>
      <div className="flex w-full items-center gap-1 border-t border-solid border-neutral-100 bg-neutral-50 px-5 py-3">
        {variant === "scope" ? (
          <Skeleton className="h-4 w-40 rounded" />
        ) : (
          <>
            <Skeleton className="h-4 w-12 rounded" />
            <Skeleton className="h-4 w-36 rounded" />
          </>
        )}
      </div>
    </div>
  );
}
